module.exports = __webpack_public_path__ + "img/Snapp-Logo-Color.98c8cc5d.png";